/**
 * Lemon Squeezy overlay checkout for Pro subscriptions.
 * Requires the user to be signed in - this guarantees that the
 * webhook fulfillment can attach the purchase to a real profile,
 * and lets us prefill the buyer's email at Lemon Squeezy.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { openCheckout } from '@/lib/openCheckout';

export type CheckoutProduct = 'pro' | 'copilot';
export type BillingInterval = 'monthly' | 'yearly';

const LS_URLS = {
  pro_monthly: 'https://iso-27001-kit.lemonsqueezy.com/checkout/buy/094e3b3b-a6d9-4f91-adce-e798852841b6',
  pro_yearly: 'https://iso-27001-kit.lemonsqueezy.com/checkout/buy/1ec86ec6-a228-4ed5-859b-76db376360a2',
};

interface LemonCheckoutProps {
  open: boolean;
  onClose: () => void;
  product?: CheckoutProduct;
  interval?: BillingInterval;
}

export function LemonCheckout({ open, onClose, product = 'pro', interval = 'monthly' }: LemonCheckoutProps) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!open || loading) return;
    const base = interval === 'yearly' ? LS_URLS.pro_yearly : LS_URLS.pro_monthly;
    openCheckout({
      url: base,
      user,
      navigate,
      redirectAfterAuth: '/account',
      intent: 'buy-pro',
      productLabel: 'Pro',
    });
    onClose();
  }, [open, loading, user, interval, navigate, onClose]);

  return null;
}
